import { Select } from '@/ui/primitives/select';
import { type Perfil, type UsuarioResumo } from '@fiscoai/contracts';

/** Valor do Select para "sem perfil de plataforma" (o Radix não aceita valor vazio). */
const SEM_PERFIL = 'nenhum';
const ROTULO_SEM_PERFIL = 'Só por empresa';

export function TextoPerfilPlataforma({ usuario }: { usuario: UsuarioResumo }) {
  return (
    usuario.perfilPlataforma?.nome ?? <span className="text-texto-fraco">{ROTULO_SEM_PERFIL}</span>
  );
}

interface Props {
  usuario: UsuarioResumo;
  /** Todos os perfis: só os de escopo PLATAFORMA viram opção. */
  perfis: readonly Perfil[];
  aoMudar: (usuario: UsuarioResumo, chave: string | null) => void;
}

/** Troca o perfil de plataforma de alguém na própria linha da tabela (só para quem gerencia). */
export function SeletorPerfilPlataforma({ usuario, perfis, aoMudar }: Props) {
  const opcoes = [
    ...perfis
      .filter((p) => p.escopo === 'PLATAFORMA')
      .map((p) => ({ valor: p.chave, rotulo: p.nome })),
    { valor: SEM_PERFIL, rotulo: ROTULO_SEM_PERFIL },
  ];
  return (
    <Select
      aria-label={`Perfil na plataforma de ${usuario.nome}`}
      opcoes={opcoes}
      valor={usuario.perfilPlataforma?.chave ?? SEM_PERFIL}
      aoMudar={(valor) => {
        aoMudar(usuario, valor === SEM_PERFIL ? null : valor);
      }}
      className="h-8 max-w-[13rem]"
    />
  );
}
